if (!customElements.get("m-product-details-tabs")) {
  class MProductDetailsTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = new Theme.Tabs(this);
      this.initMobileSelect();

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (event) => {
          const tabHeader = event && event.target;
          const index = (tabHeader && Number(tabHeader.dataset.index)) || 0;
          this.tabs && this.tabs.setActiveTab(index);
        });
      }
    }

    initMobileSelect() {
      this.select = this.querySelector("[data-tab-select]");
      this.select && this.select.addEventListener("change", () => {
        this.tabs.setActiveTab(parseInt(this.select.value));
      });
    }
  }
  customElements.define("m-product-details-tabs", MProductDetailsTabs);
}
